const accessKeyId = "AKIA422OL33WIOTSUA6I";
const secretAccessKey = "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";

export {accessKeyId,secretAccessKey};
